// extracted by mini-css-extract-plugin
export default {"container":"RecaptchaDisclaimer_container__MnqWF","link":"RecaptchaDisclaimer_link__diqtD"};